import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Container } from '../components/layout/primitives';
import { AgentConfigPanel } from '../components/AgentConfig/AgentConfigPanel';

const AgentConfig: React.FC = () => {
  const { agentId } = useParams<{ agentId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  if (!agentId) return null;

  const initialTab = searchParams.get('tab') ?? 'overview';

  return (
    <div className="relative min-h-full">
      {/* Ambient decorative blobs behind the content (see ModernLayout for the
          page-wide gradient wash). Purely visual, non-interactive. */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-24 top-40 h-72 w-72 rounded-full bg-c-a9c7e6/25 blur-3xl" />
        <div className="absolute -left-10 bottom-24 h-64 w-64 rounded-full bg-c-c9b8ec/25 blur-3xl" />
        <div className="absolute right-8 top-8 h-56 w-56 rounded-full bg-[#f3c6cf]/25 blur-3xl" />
      </div>
      <Container size="content" className="relative pb-16 pt-8">
        <AgentConfigPanel
          key={initialTab}
          agentId={agentId}
          initialTab={initialTab}
          onDelete={() => navigate('/agents')}
        />
      </Container>
    </div>
  );
};

export default AgentConfig;
